import { Field, Form, Formik } from "formik";
import { lotterySchema } from "../../yupSchema/lotterySchema";
import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";
import {
  LotteryHLCompanyConst,
  LotteryMKTCompanyConst,
} from "../../../../constants/LotteryCompanyConst";
import { CheckIsNull, toAbsoluteUrl } from "../../../../utils/CommonHelper";
import { LotteryTypeConst } from "../../../../constants/LotteryNavConst";

const BetTypeConst = ["Box", "IBox"];

export const LotteryBetForm = ({ saveValues, lotteryType }) => {
  const intl = useIntl();
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [betType, setBetType] = useState("");
  const [activeInput, setActiveInput] = useState("luckyNumber");
  const [number, setNumber] = useState("");

  const bigRef = useRef(null); // Ref for the 'big' input field
  const numberRef = useRef(null);

  useEffect(() => {
    setSelectedCompany([]);
  }, [lotteryType]);

  const handleFocus = (e) => {
    e.target.select();
  };
  const PermAlone = (str) => {
    let arr = str.split("");
    let reg = /(.)\1+/;
    let perms = 0;
    function swap(indexFrom, indexTo, arr) {
      if (indexTo === arr.length - 1) {
        let enterStr = arr.join("");
        if (!reg.test(enterStr)) perms++;
      } else {
        let newArr = [];
        for (let i = 0; i < arr.length; i++) {
          newArr.push(arr[i]);
        }
        let temp = newArr[indexFrom];
        newArr[indexFrom] = newArr[indexTo];
        newArr[indexTo] = temp;

        for (let i = indexTo + 1; i < arr.length; i++) {
          swap(i, indexTo + 1, newArr);
        }
      }
    }
    for (let i = 0; i < arr.length; i++) {
      swap(i, 0, arr);
    }

    return perms;
  };

  // const GetNumDiffer = (numDiffers) => {
  //   let countDiffer = 0;
  //   for (const numDiffer in numDiffers) {
  //     if (numDiffers.hasOwnProperty(numDiffer)) {
  //       ++countDiffer;
  //     }
  //   }
  //   return countDiffer;
  // };

  const BoxMultiply = (value) => {
    const arr = !CheckIsNull(value) ? value.toString().split("") : [];
    let numDiffers = {};
    let totalBox = "0";

    for (let i = 0; i < arr.length; i++) {
      numDiffers[arr[i]] = 1 + (numDiffers[arr[i]] || 0);
    }

    const countDiffer = Object.keys(numDiffers).length;
    if (countDiffer === 2) {
      const perms = PermAlone(value.toString());
      totalBox = perms === 0 ? "4" : perms === 8 ? "6" : perms.toString();
    } else {
      totalBox = countDiffer === 1 ? "1" : countDiffer === 3 ? "12" : "24";
    }

    return totalBox;
  };

  useEffect(() => {
    if (activeInput === "luckyNumber") {
      numberRef.current?.focus();
    }
    if (number.toString().length >= 4) {
      bigRef.current?.focus();
      setActiveInput("bNumber");
    }
  }, [number]);

  return (
    <>
      <Formik
        initialValues={{
          number: "",
          big: "0",
          small: "0",
          fourA: "0",
        }}
        validationSchema={lotterySchema(intl)}
        enableReinitialize={true}
        onSubmit={(values, formikHelpers) => {
          if (selectedCompany.length > 0) {
            const subTotal =
              (parseFloat(values.big ? values.big : "0") +
                parseFloat(values.small ? values.small : "0") +
                parseFloat(values.fourA ? values.fourA : "0")) *
              (betType === BetTypeConst[0] ? BoxMultiply(values.number) : "1") *
              selectedCompany.length;

            const companyList = selectedCompany
              .map((company) => company.lotteryKeyCode)
              .join("");

            const longCode = {
              key: Date.now(),
              companyList: selectedCompany,
              number: values.number,
              big: values.big,
              small: values.small,
              fourA: values.fourA,
              betType,
              subTotal,
              code: `#${companyList}|${
                betType === BetTypeConst[0]
                  ? "*"
                  : betType === BetTypeConst[1]
                  ? "**"
                  : ""
              }${values.number}#${values.big}#${values.small}#${values.fourA}`,
            };

            saveValues(longCode);
            setBetType("");
            setActiveInput("luckyNumber");
            formikHelpers.setFieldValue("number", "");
          }
        }}
      >
        {({
          values,
          handleSubmit,
          setFieldValue,
          touched,
          errors,
          setFieldError,
          setFieldTouched,
        }) => {
          const handleInputClick = (inputName) => {
            setActiveInput(inputName);
          };

          return (
            <Form onSubmit={handleSubmit}>
              <div className="mb-2">
                <label className="mb-2 text-input-label text-font3">
                  {intl.formatMessage({ id: "chooseCompany" })}
                </label>
                <div className="d-flex align-items-center w-100">
                  {(lotteryType === LotteryTypeConst.HL_LOTTERY
                    ? LotteryHLCompanyConst
                    : LotteryMKTCompanyConst
                  ).map((lotteryCompany, index) => (
                    <div
                      className={`d-flex flex-column align-items-center justify-content-center overflow-scroll text-font2 ${
                        index === 0 ? "me-1" : "mx-1"
                      } py-2 px-1 rounded cursor-pointer ${
                        selectedCompany.filter(
                          (company) =>
                            company.lotteryCode === lotteryCompany.lotteryCode
                        ).length > 0
                          ? "text-dark"
                          : ""
                      }`}
                      key={index}
                      style={{
                        width: "45px",
                        userSelect: "none",
                        background:
                          selectedCompany.filter(
                            (company) =>
                              company.lotteryCode === lotteryCompany.lotteryCode
                          ).length > 0
                            ? "#d1ffbd"
                            : "rgba(255, 255, 255, 0.1)",
                      }}
                      onClick={() => {
                        if (
                          selectedCompany.filter(
                            (company) =>
                              company.lotteryCode === lotteryCompany.lotteryCode
                          ).length > 0
                        ) {
                          setSelectedCompany(
                            selectedCompany.filter(
                              (company) =>
                                company.lotteryCode !==
                                lotteryCompany.lotteryCode
                            )
                          );
                        } else {
                          setSelectedCompany([
                            ...selectedCompany,
                            lotteryCompany,
                          ]);
                        }
                      }}
                    >
                      <img
                        src={toAbsoluteUrl(lotteryCompany.lotteryUrl)}
                        alt={lotteryCompany.lotteryCode}
                        className="w-100"
                      />
                      <div className="mt-2 fw-bold">
                        {lotteryCompany.lotteryCode}
                      </div>
                    </div>
                  ))}
                </div>
                {selectedCompany.length <= 0 && (
                  <div className="fv-plugins-message-container text-danger mt-1">
                    <div className="fv-help-block">
                      <span role="alert">
                        {intl.formatMessage({ id: "companyRequired" })}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className="d-flex">
                <div className="col-12 me-3">
                  <div className="mb-2 text-font3">
                    <label>{intl.formatMessage({ id: "number" })}</label>
                    <div>
                      <input
                        ref={numberRef}
                        name="number"
                        type="number"
                        value={values.number}
                        onChange={(e) => {
                          let newValue = e.target.value;
                          setNumber(newValue === "" ? "0" : newValue);
                          setFieldValue(
                            "number",
                            newValue === "" ? "0" : newValue
                          );
                        }}
                        placeholder={intl.formatMessage({ id: "number" })}
                        style={{
                          width: "100%",
                          height: 35,
                          borderRadius: 5,
                          boxSizing: "border-box",
                          padding: "0 5px",
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                          color: "white",
                          border:
                            activeInput === "luckyNumber"
                              ? "2px solid rgb(245, 190, 9)"
                              : "none",
                          boxShadow:
                            activeInput === "luckyNumber"
                              ? "0 0 5px rgb(245, 190, 9)"
                              : "none",
                        }}
                        onClick={() => handleInputClick("luckyNumber")}
                        onFocus={handleFocus}
                      />
                    </div>
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-between mb-2 text-font3"
                    style={{ gap: "0.5rem" }}
                  >
                    <div className="flex-fill">
                      <label>{intl.formatMessage({ id: "big" })}</label>
                      <input
                        ref={bigRef}
                        name="big"
                        type="number"
                        value={values.big}
                        onChange={(e) => {
                          let newValue = e.target.value;
                          if (/^\d*$/.test(newValue)) {
                            if (
                              newValue.startsWith("0") &&
                              newValue.length > 1
                            ) {
                              newValue = newValue.replace(/^0+/, "");
                            }
                            setFieldValue(
                              "big",
                              newValue === "" ? "0" : newValue
                            );
                          }
                        }}
                        placeholder={intl.formatMessage({ id: "big" })}
                        style={{
                          width: "100%",
                          height: 35,
                          borderRadius: 5,
                          boxSizing: "border-box",
                          padding: "0 5px",
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                          color: "white",
                          border:
                            activeInput === "bNumber"
                              ? "2px solid rgb(245, 190, 9)"
                              : "none",
                          boxShadow:
                            activeInput === "bNumber"
                              ? "0 0 5px rgb(245, 190, 9)"
                              : "none",
                        }}
                        onClick={() => handleInputClick("bNumber")}
                        onFocus={handleFocus}
                      />
                    </div>
                    <div className="flex-fill">
                      <label>{intl.formatMessage({ id: "small" })}</label>
                      <input
                        name="small"
                        type="number"
                        value={values.small}
                        onChange={(e) => {
                          let newValue = e.target.value;
                          if (/^\d*$/.test(newValue)) {
                            if (
                              newValue.startsWith("0") &&
                              newValue.length > 1
                            ) {
                              newValue = newValue.replace(/^0+/, "");
                            }
                            setFieldValue(
                              "small",
                              newValue === "" ? "0" : newValue
                            );
                          }
                        }}
                        placeholder={intl.formatMessage({ id: "small" })}
                        style={{
                          width: "100%",
                          height: 35,
                          borderRadius: 5,
                          boxSizing: "border-box",
                          padding: "0 5px",
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                          color: "white",
                          border:
                            activeInput === "sNumber"
                              ? "2px solid rgb(245, 190, 9)"
                              : "none",
                          boxShadow:
                            activeInput === "sNumber"
                              ? "0 0 5px rgb(245, 190, 9)"
                              : "none",
                        }}
                        onClick={() => handleInputClick("sNumber")}
                        onFocus={handleFocus}
                      />
                    </div>
                    <div className="flex-fill">
                      <label>{intl.formatMessage({ id: "4a" })}</label>
                      <input
                        name="fourA"
                        type="number"
                        value={values.fourA}
                        onChange={(e) => {
                          let newValue = e.target.value;
                          if (/^\d*$/.test(newValue)) {
                            if (
                              newValue.startsWith("0") &&
                              newValue.length > 1
                            ) {
                              newValue = newValue.replace(/^0+/, ""); // Remove leading zeros
                            }
                            setFieldValue(
                              "fourA",
                              newValue === "" ? "0" : newValue
                            );
                          }
                        }}
                        placeholder={intl.formatMessage({ id: "4a" })}
                        style={{
                          width: "100%",
                          height: 35,
                          borderRadius: 5,
                          boxSizing: "border-box",
                          padding: "0 5px",
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                          color: "white",
                          border:
                            activeInput === "aNumber"
                              ? "2px solid rgb(245, 190, 9)"
                              : "none",
                          boxShadow:
                            activeInput === "aNumber"
                              ? "0 0 5px rgb(245, 190, 9)"
                              : "none",
                        }}
                        onClick={() => handleInputClick("aNumber")}
                        onFocus={handleFocus}
                      />
                    </div>
                  </div>
                  {parseFloat(values.big ? values.big : "0") +
                    parseFloat(values.small ? values.small : "0") +
                    parseFloat(values.fourA ? values.fourA : "0") <=
                    "0" && (
                    <div className="fv-plugins-message-container text-danger">
                      <div className="fv-help-block">
                        <span role="alert">
                          {intl.formatMessage({ id: "sumMin1" })}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex">
                <div className="col-7">
                  <label className="mb-2 text-input-label text-font3">
                    {intl.formatMessage({ id: "betType" })}
                  </label>
                  <div className="d-flex" style={{ gap: "0.5rem" }}>
                    {BetTypeConst.map((bet, index) => (
                      <div
                        className={`cursor-pointer py-1 text-font3 rounded text-center ${
                          betType === bet
                            ? "bg-light-success text-dark fw-bold"
                            : "bg-hover"
                        }`}
                        style={{ width: "48%" }}
                        key={index}
                        onClick={() => {
                          if (betType === bet) {
                            setBetType("");
                          } else {
                            setBetType(bet);
                          }
                        }}
                      >
                        {bet}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-5 d-flex flex-column ps-2">
                  <div
                    className="p-2 text-end"
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "5px",
                    }}
                  >
                    <label className="text-input-label text-font3">
                      {intl.formatMessage({ id: "estimatePrice" })}
                    </label>
                    <div className="fw-bold text-font3">
                      {CheckIsNull(values.number) ||
                      values.number.toString().length < 4
                        ? "0.00"
                        : parseFloat(
                            (parseFloat(values.big ? values.big : "0") +
                              parseFloat(values.small ? values.small : "0") +
                              parseFloat(values.fourA ? values.fourA : "0")) *
                              (betType === BetTypeConst[0]
                                ? BoxMultiply(values.number)
                                : "1") *
                              selectedCompany.length
                          ).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end mt-2">
                <button
                  type="submit"
                  className="btn btn-prim px-4 py-1 text-font3"
                >
                  {intl.formatMessage({ id: "add" })}
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
